import React from "react";
import LsLoading from "Components/LsLoading";
import Modal from "./Modal";

const ModalLoading: React.FC = () => {
   return <Modal wrapClassName='modal-loading-wrapper' isOpen centered>
      <LsLoading isLoading />
   </Modal>
}

export default ModalLoading;
